import React, { lazy } from "react";
import { useRoutes, useNavigate, Navigate } from "react-router-dom";
import { storageConstants } from "./common/utils/constants";

const Login = lazy(() => import("./components/Login/Login"));
const Dashboard = lazy(() => import("./components/Dashboard/Dashboard"));

const UserManagement = lazy(() =>
  import("./components/UserManagement/UserManagement")
);
const SubscriptionManagement = lazy(() =>
  import("./components/Subscription/Subscription")
);

const QuoteManagement = lazy(() =>
  import("./components/QuoteManagement/QuoteMenegement")
);

const QuoteDetails = lazy(() =>
  import("./components/QuoteManagement/QuoteDetails")
);

const EmotionManagement = lazy(() =>
  import("./components/EmotionManagement/EmotionMenegement")
);
const CategoriesManagement = lazy(() =>
  import("./components/CategoriesManagement/CategoriesManagement")
);

const ActivityManagement = lazy(() =>
  import("./components/ActivityManagement/ActivityManagement")
);
const ViewActivity = lazy(() =>
  import("./components/ActivityManagement/ViewActivity")
);

const NotificationManagement = lazy(() =>
  import("./components/Notification/ListNotification/ListNotification")
);
const CreateNotification = lazy(() =>
  import("./components/Notification/CreateNotification/CreateNotification")
);
const ViewNotification = lazy(() =>
  import("./components/Notification/ViewNotification/ViewNotification")
);

const AlarmManement = lazy(() =>
  import("./components/AlarmManagement/AlarmManagement")
);

const AlarmDetails = lazy(() =>
  import("./components/AlarmManagement/AlarmDetails")
);

const Profile = lazy(() => import("./components/Profile/Profile"));
const SystemSettings = lazy(() =>
  import("./components/SystemSettings/SystemSettings")
);

const ViewAccount = lazy(() =>
  import("./components/Accounts/ViewAccount/ViewAccount")
);
const NotFound = lazy(() => import("./components/common/error/NotFoundError"));
const InternalServerError = lazy(() =>
  import("./components/common/error/InternalServerError")
);
const UserDetails = lazy(() =>
  import("./components/UserManagement/UserDetails")
);

const EmotionDetails = lazy(() =>
  import("./components/EmotionManagement/EmotionDetails")
);

const ActivityDetails = lazy(() =>
  import("./components/ActivityManagement/ActivityDetails")
);

const Remember = lazy(() => import("./components/Remember/Remember"));

const Connect = lazy(() => import("./components/Connect/Connect"));
const TrailConfiguration = lazy(() => import("./components/TrailConfiguration/TrailConfiguration"));
const Transactions =  lazy(() => import("./components/Transactions/TransactionManagement"));

const authenticatedRoutes = (props) => {
  return [
    {
      path: storageConstants.PAGES.ROUTE.DASHBOARD,
      element: <Dashboard {...props} />,
    },
    {
      path: storageConstants.PAGES.ROUTE.USER_MANAGEMENT,
      // element: <UserManagement {...props} exact/>,
      children: [
        {
          index: true,
          //  path: "request-verification",
          element: <UserManagement {...props} />,
        },
        {
          path: `user/:id`,
          element: <UserDetails {...props} />,
        },
      ],
    },
    {
      path: storageConstants.PAGES.ROUTE.QUOTE_MANAGEMENT,
      // element: <QuoteManagement {...props} />,
      children: [
        {
          index: true,
          element: <QuoteManagement {...props} />,
        },
        {
          path: `quote/:id`,
          element: <QuoteDetails {...props} />,
        },
      ],
    },
    {
      path: storageConstants.PAGES.ROUTE.EMOTION_MANAGEMENT,
      // element: <EmotionManagement {...props} />,
      children: [
        {
          index: true,
          element: <EmotionManagement {...props} />,
        },
        {
          path: `emotion/:key/:id`,
          element: <EmotionDetails {...props} />,
        },
      ],
    },
    {
      path: storageConstants.PAGES.ROUTE.ACTIVITY_MANAGEMENT,
      children: [
        {
          index: true,
          element: <ActivityManagement {...props} />,
        },
        {
          path: "view",
          element: <ViewActivity {...props} />,
        },
        {
          path: `activity/:key/:id`,
          element: <ActivityDetails {...props} />,
        },
      ],
    },
    {
      path: storageConstants.PAGES.ROUTE.CONTENT_REPORT_MANAGEMENT,
    },

    {
      path: storageConstants.PAGES.ROUTE.PROFILE,
      element: <Profile {...props} />,
    },
    {
      path: storageConstants.PAGES.ROUTE.SYSTEM_SETTINGS_AND_CONFIGURATION,
      element: <SystemSettings {...props} />,
    },
    {
      path: storageConstants.PAGES.ROUTE.CATEGORIES_MANAGEMENT,
      element: <CategoriesManagement {...props} />,
    },
    {
      path: storageConstants.PAGES.ROUTE.NOTIFICATIONS,
      children: [
        {
          index: true,
          element: <NotificationManagement {...props} />,
        },
        {
          path: "create",
          element: <CreateNotification {...props} />,
        },
        {
          path: "view",
          element: <ViewNotification {...props} />,
        },
      ],
    },
    {
      path: storageConstants.PAGES.ROUTE.REMEMBER_ACTIVITY,
      children: [
        {
          index: true,
          element: <Remember {...props} />,
        },
      ],
    },
    {
      path: storageConstants.PAGES.ROUTE.MANAGE_CONNECTION,
      children: [
        {
          index: true,
          element: <Connect {...props} />,
        },
      ],
    },
    {
      path: storageConstants.PAGES.ROUTE.ALARM_MANAGEMENT,
      // element: <EmotionManagement {...props} />,
      children: [
        {
          index: true,
          element: <AlarmManement {...props} />,
        },
        {
          path: `alarm/:key/:id`,
          element: <AlarmDetails {...props} />,
        },
      ],
    },
    {
      path: storageConstants.PAGES.ROUTE.ACCOUNTS,
      element: <ViewAccount {...props} />,
    },
    {
      path: storageConstants.PAGES.ROUTE.SUBSCRIPTION,
      element: <SubscriptionManagement {...props} />,
    },
    {
      path: storageConstants.PAGES.ROUTE.TRAIL_CONFIGURATION,
      element: <TrailConfiguration {...props} />,
    },
    {
      path: storageConstants.PAGES.ROUTE.TRANSACTIONS,
      element: <Transactions {...props} />,
    },
    {
      path: "500",
      element: <InternalServerError {...props} />,
    },
    {
      path: "*",
      element: <NotFound {...props} />,
    },
    {
      path: storageConstants.PAGES.ROUTE.NOTIFICATIONS,
      // element: <Notifications {...props} exact/>,
      children: [
        {
          index: true,
        },
      ],
    },
    {
      path: storageConstants.PAGES.ROUTE.HASHTAGS,
      // element: <Notifications {...props} exact/>,
      children: [],
    },
  ];
};

const unauthenticatedRoutes = (props) => {
  return [
    {
      path: storageConstants.PAGES.ROUTE.LOGIN,
      element: <Login {...props} />,
    },
  ];
};

const Routes = (props) => {
  const navigate = useNavigate();
  const isAuthenticated =
    props.user?.isAuthenticated || localStorage.getItem("token") ? true : false;
  // const isAuthenticated = true;

  const routingConfig = useRoutes(
    isAuthenticated ? authenticatedRoutes(props) : unauthenticatedRoutes(props)
    // isAuthenticated ? authenticatedRoutes : unauthenticatedRoutes
  );

  // Redirect to login if user is not authenticated
  React.useEffect(() => {
    if (!isAuthenticated) {
      navigate(storageConstants.PAGES.ROUTE.LOGIN);
    }
  }, [navigate]);

  return routingConfig;
};

export default Routes;
